const config = {
    PRODUCTION: true,
    DEBUGMODE: true,
    roles: {
        opublic: ['public'],
        public: ['public', 'guest', 'manager', 'administrator'],
        guest: ['guest', 'manager', 'administrator'],
        manager: ['manager', 'administrator'],
        administrator: ['administrator']
    }
}


// we have this if but we can't use because
// we need the variable in build before upload on the server
// **(window.location.origin.includes('bop-web.com')) ? true : false**
config.frontpoint = config.PRODUCTION ? "https://mobiletechzone.at/" : "https://localhost:8080/";
// TODO: add link url of hostinger
config.endpoint = config.PRODUCTION ? "https://kwieder.com/api-projects/mobile-tech-zone/api/" : "https://kwieder.com/api-projects/mobile-tech-zone/api/";
// config.endpoint = config.PRODUCTION ? "https://kwieder.com/api-projects/mobile-tech-zone/api/" : "http://localhost/mtz_app/api/";
// "http://localhost/mtz_app/api/"
export default config;
